module.exports = __webpack_public_path__ + "img/xingxing_icon.6ed9efe8.png";